import React, { useState, useEffect } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

export const CPackageSection = ({ id }) => {
  const [packages, setPackages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [selectedPackage, setSelectedPackage] = useState(null);

  const charLimit = 350;

  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Packages/GetPackagesDetailsById?displayedInId=${id}`
      );
      if (list && list.length > 0) {
        setPackages(list);
      } else {
        setPackages([]);
      }
    } catch (error) {
      setPackages([]);
      console.error("Error fetching list:", error);
    }
  };

  const handleShowModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  const handleOpenModal = (pkg) => {
    setSelectedPackage(pkg);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setSelectedPackage(null);
    setShowModal(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!packages || packages.length === 0) {
    return null;
  }
  const formatCount = (count) => {
    if (count >= 1000000000) {
      return (
        (count / 1000000000).toFixed(count % 1000000000 === 0 ? 0 : 1) + "B"
      );
    } else if (count >= 1000000) {
      return (count / 1000000).toFixed(count % 1000000 === 0 ? 0 : 1) + "M";
    } else if (count >= 1000) {
      return (count / 1000).toFixed(count % 1000 === 0 ? 0 : 1) + "k";
    }
    return count.toString();
  };
  const handleClickPackagePoints = (content) => {
    setModalContent(content); // Set the content of the modal
    setShowModal(true); // Open the modal
  };
  return (
    <>
      <section className="about section-padding bg-white" id="PricingPackages">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Choose Yours</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Corporate Packages</div>
              <div className="row">
                {packages.map((pkg, index) => (
                  <div className="col-md-4 package-card-wrapper" key={index}>
                    <div className="package-card">
                      <h4>{pkg.packageName}</h4>
                      <span
                        style={{
                          color: "#000", // Black color for Read More link
                          fontSize: "14px", // Font size for the Read More text
                          margin: "0", // Remove default margin
                          cursor: "pointer",
                          marginBottom: "10px",
                        }}
                      >
                        Starts From
                      </span>
                      <h2>${formatCount(pkg.amount)}</h2>
                      <div>
                        {/* Package Points Section */}
                        <div
                          className="customFontFamily"
                          style={{
                            cursor: "pointer",
                            height: "216px",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between", // Space between text and Read More
                          }}
                          onClick={() =>
                            handleClickPackagePoints(pkg.packagesPoints)
                          }
                        >
                          <div
                            style={{
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: 6, // Adjust the number of lines for ellipsis
                              WebkitBoxOrient: "vertical",
                              maxHeight: "calc(12em)", // 1.2em for line height, multiplied by the number of lines
                              lineHeight: "1.2em", // Match the line height
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Outfit, sans-serif",
                              }}
                            >
                              <div>
                                {pkg.packagesPoints.replace(
                                  /<\/?[^>]+(>|$)/g,
                                  ""
                                )}
                              </div>
                            </span>
                          </div>

                          {/* 'Read More' Section */}
                          {pkg.packagesPoints.length > charLimit && (
                            <span
                              style={{
                                color: "#000",
                                fontSize: "14px",
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                              onClick={() => handleOpenModal(pkg)}
                            >
                              Read More
                            </span>
                          )}
                        </div>
                        <br></br>
                        {/* Buttons Section */}
                        <div className="book">
                          <div>
                            <a
                              href={pkg.button1Link}
                              className="butn-dark2 cta"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-block",
                                width: "200px",
                                textAlign: "center",
                              }}
                            >
                              <span>{pkg.button1Name}</span>
                            </a>
                          </div>
                          <div>
                            <a
                              href={pkg.button2Link}
                              className="butn-dark2"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-block",
                                width: "200px",
                                textAlign: "center",
                              }}
                            >
                              <span>{pkg.button2Name}</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for full description */}
      {showModal && selectedPackage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000, // Ensure the background layer has a low z-index
          }}
        >
          <div
            style={{
              position: "relative", // Added this to ensure absolute positioning of the close button works
              marginTop: "100px",
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "20px",
              maxWidth: "800px",
              width: "90%",
              maxHeight: "80%",
              overflow: "hidden",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <span
              style={{
                fontSize: "24px",
                cursor: "pointer",
                position: "absolute",
                top: "10px",
                right: "15px",
                zIndex: 1010, // Ensure close button is above the modal
              }}
              onClick={handleCloseModal}
            >
              &times;
            </span>
            <div
              className="modal-header"
              // style={{
              //   fontSize: "20px",
              //   fontWeight: "bold",
              //   marginBottom: "15px",
              //   color: "#d4b0a5",e
              // }}
            >
              {selectedPackage.packageName}
            </div>
            <div
              style={{
                maxHeight: "calc(80vh - 100px)",
                overflowY: "auto",
                paddingRight: "10px",
              }}
            >
              <p dangerouslySetInnerHTML={{ __html: modalContent }}></p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
